// extracted by mini-css-extract-plugin
export default {"wrapper":"yd-z","side":"zd-z","boxNumSelection":"Ad-z","disabled":"Bd-z","boxInfoMsg":"Cd-z","noReturnItems":"Dd-z","breadcrumb":"Ed-z"};